class DropdownDisclosure extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.init();
    this.attachEvents();
  }

  attachEvents() {
    document.addEventListener('click', event => {
      if (this.querySelector('details').hasAttribute('open') && event.target !== this.querySelector('summary') && event.target.closest('details') !== this.querySelector('details')) {
        this.onClickOutside(event);
      }
    });
  }

  init() {
    this.querySelector("summary").addEventListener(
      "click",
      this.onSummaryClick.bind(this)
    );
  }

  onClickOutside(event) {
    const summaryElement = this.querySelector('summary');
    const detailsElement = this.querySelector('details');

    this.close(summaryElement, detailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const isOpen = detailsElement.hasAttribute("open");

    isOpen
      ? this.close(summaryElement, detailsElement, event)
      : this.open(summaryElement, detailsElement);
  }

  open(summaryElement, detailsElement) {
    setTimeout(() => {
      detailsElement.classList.add("is-open");
    });
    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(detailsElement, summaryElement);
  }

  close(summaryElement, detailsElement, event) {
    if (event) {
      event.preventDefault();
    }

    detailsElement.classList.remove("is-open");
    removeTrapFocus(summaryElement);
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      elapsedTime < 400
        ? window.requestAnimationFrame(handleAnimation)
        : detailsElement.removeAttribute("open");
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define("dropdown-disclosure", DropdownDisclosure);
